module.exports = __webpack_public_path__ + "assets/logo-loader.799b2720.svg";